import React, { useState, useRef } from 'react';
import { Document, Page } from 'react-pdf';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/solid';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function PdfViewer(props) {
  const ref = useRef(null);
  const params = useParams();
  const [numPages, setNumPages] = useState(null);
  const [pdfUrl] = useState(atob(params.url));
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1);
  const { t } = useTranslation();

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const OnDocumentLoadError = (error) => {
    throw error;
  };

  const onPageLoad = (page) => {
    if (!ref) {
      return;
    }
    let scale = ref.current.clientWidth / page.originalWidth;
    setScale(Math.min(scale, 1.2));
  };

  return (
    <div className="w-screen bg-grey-medium_light flex flex-col space-y-3">
      {/* Pdf renderer */}
      <div ref={ref}>
        <Document
          file={{ url: pdfUrl }}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={OnDocumentLoadError}
        >
          <Page
            pageNumber={pageNumber}
            scale={scale}
            onLoadSuccess={onPageLoad}
          />
        </Document>
      </div>

      {/* Navigation */}
      <div className="fixed bottom-5 w-screen">
        <div className="flex justify-center m-auto space-x-3 ">
          <button
            className="bg-sky rounded-md p-2 text-white hover:bg-sky-dark"
            onClick={() => {
              setPageNumber(Math.max(1, pageNumber - 1));
            }}
          >
            <ChevronLeftIcon className="w-5" />
          </button>
          <p className="font-bold text-sky mt-1">
            {t('posts.page')} {pageNumber} {t('posts.of')} {numPages}
          </p>
          <button
            className="bg-sky rounded-md p-2 text-white hover:bg-sky-dark"
            onClick={() => {
              setPageNumber(Math.min(numPages, pageNumber + 1));
            }}
          >
            <ChevronRightIcon className="w-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
